function loading_display(display) {
    document.getElementById('loading').style.display = display ? 'initial' : 'none'
}

export default loading_display;